<template>
  <div class="room_bottom" v-bind:class="{'active' : isActive || isCanBooking}">
    <div v-if="isExpanded" class="room_bottom_extended">
      <div class="room_extended_text">延長リクエスト済み</div>
    </div>
    <div v-else-if="isCanBooking" class="room_bottom_btn active">
      <a href="javascript:void(0)" @click="$emit('click_booking')" class="room_bottom_btn_link">
        <div class="room_bottom_btn_text">予約する</div>
      </a>
    </div>
    <div v-else class="room_bottom_btn active">
      <a href="javascript:void(0)" @click="$emit('click_extend')" class="room_bottom_btn_link">
        <div class="room_bottom_btn_text">延長する</div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      required: false
    },
    isExpanded: {
      type: Boolean,
      required: false
    },
    isCanBooking: {
      type: Boolean,
      required: false
    }
  },
  created: function() {},
  methods: {}
};
</script>

<style lang="scss">
/** 下部エリア **/
.room_bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 90px;
  display: none;
  justify-content: center;
  align-items: center;
}

/** 下部エリア表示 **/
.room_bottom.active {
  display: flex;
}

/** 延長するボタン **/
.room_bottom_btn {
  width: 80%;
  background-color: $txtColor;
  border-radius: 5px;
}

.room_bottom_btn_link {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 14px;
  box-sizing: border-box;
}

.room_bottom_btn_icon {
  width: 40px;
}

.room_bottom_btn_icon > img {
  width: 30px;
}

.room_bottom_btn_text {
  color: #fff;
  font-size: 18px;
}

/** 反転 - 延長するボタン **/
.room_bottom_btn.active {
  background-color: $btnColor;
}

/** 延長リクエスト済み **/
.room_bottom_extended {
  width: 80%;
  border-radius: 5px;
  padding: 14px;
  background-color: #aaa;
  color: #fff;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.room_extended_text {
  font-size: 18px;
}
</style>